import { MessageBlock } from "@/types";

export const lastReceivedMessageFromBlocks = (blocks: ReadonlyArray<MessageBlock>) => {
  const len = blocks.length;

  for (let i = 0; i < len; i++) {
    const block = blocks[len - 1 - i];
    if (!block.lastMessage.ownMessage) {
      return block.lastMessage;
    }
  }

  return null;
};
